export default __webpack_public_path__ + "bc9a05314d81d5b9e03989b113b772a6.png";